// extracted by mini-css-extract-plugin
export default {"header_text":"terms_of_use_header_text__+rRQj","sub_text":"terms_of_use_sub_text__dqdL9"};